import React from 'react';
import FaPaper from "../FactureeComponents/FaPaper";
import {Box, Divider, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper} from "@mui/material";
import ShowCode from "../helpers/ShowCode.js";

const FactureeCompPaperExmpl = () => {

  const example1 = `<>
  <FaPaper headline={"This is a paper Element with small padding."} padding="small" sx={{maxWidth: '40vw'}}>
    <Typography>
      Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor.
      Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.
    </Typography>
  </FaPaper>
</>`;

  const example2 = `<>
  <FaPaper headline={"This is a paper Element with medium padding (default)."} sx={{maxWidth: '50vw'}}>
    <Typography>
      Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor.
      Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.
    </Typography>
  </FaPaper>
</>`;

  const example3 = `<>
  <FaPaper headline={"This is a paper Element with large padding."} padding="large" sx={{maxWidth: '60vw'}}>
    <Typography>
      Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor.
      Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.
    </Typography>
  </FaPaper>
</>`;

  const example4 = `<>
  <FaPaper headline={"This is a paper Element with xlarge padding."} padding="xlarge" sx={{maxWidth: '70vw'}}>
    <Typography>
      Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor.
      Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.
    </Typography>
  </FaPaper>
</>`;

  return (
      <Box sx={{padding: '8rem 8vw 2rem 8vw'}}>
        <Typography variant={"h3"} sx={{marginBottom: '1rem'}}>FaPaper Component</Typography>
        <Typography sx={{marginBottom: '2rem'}}>A paper component with a box wrapper and standard padding definitions.</Typography>

        <Divider/>

        <Typography variant={"h4"} sx={{marginBottom: '1.5rem', marginTop: '2.5rem'}}>Small Padding</Typography>
        <FaPaper headline={"This is a paper Element <br> with small padding."} padding="small" sx={{maxWidth: '40vw', marginBottom: '1rem'}}>
          <Typography>
            Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa.
            Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis,
            ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo,
            fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae,
            justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper
            nisi. Aenean vulputate eleifend tellus. Aenean leo ligula, porttitor eu, consequat vitae, eleifend ac, enim.
            Aliquam lorem ante, dapibus in, viverra quis, feugiat a, tellus. Phasellus viverra nulla ut metus varius
            laoreet. Quisque rutrum. Aenean imperdiet. Etiam ultricies nisi vel augue. Curabitur ullamcorper ultricies
          </Typography>
        </FaPaper>
        <ShowCode codeString={example1} scope={{ React, FaPaper, Typography }} />

        <Typography variant={"h4"} sx={{marginBottom: '1.5rem', marginTop: '2.5rem'}}>Medium Padding (Default)</Typography>
        <FaPaper headline={"This is a paper Element <br> with medium padding (default)."} sx={{maxWidth: '50vw', marginBottom: '1rem'}}>
          <Typography>
            Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa.
            Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis,
            ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo,
            fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae,
            justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper
            nisi. Aenean vulputate eleifend tellus. Aenean leo ligula, porttitor eu, consequat vitae, eleifend ac, enim.
            Aliquam lorem ante, dapibus in, viverra quis, feugiat a, tellus. Phasellus viverra nulla ut metus varius
            laoreet. Quisque rutrum. Aenean imperdiet. Etiam ultricies nisi vel augue. Curabitur ullamcorper ultricies
          </Typography>
        </FaPaper>
        <ShowCode codeString={example2} scope={{ React, FaPaper, Typography }} />

        <Typography variant={"h4"} sx={{marginBottom: '1.5rem', marginTop: '2.5rem'}}>Large Padding</Typography>
        <FaPaper headline={"This is a paper Element <br> with large padding."} padding="large" sx={{maxWidth: '60vw', marginBottom: '1rem'}}>
          <Typography>
            Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa.
            Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis,
            ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo,
            fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae,
            justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper
            nisi. Aenean vulputate eleifend tellus. Aenean leo ligula, porttitor eu, consequat vitae, eleifend ac, enim.
            Aliquam lorem ante, dapibus in, viverra quis, feugiat a, tellus. Phasellus viverra nulla ut metus varius
            laoreet. Quisque rutrum. Aenean imperdiet. Etiam ultricies nisi vel augue. Curabitur ullamcorper ultricies
          </Typography>
        </FaPaper>
        <ShowCode codeString={example3} scope={{ React, FaPaper, Typography }} />

        <Typography variant={"h4"} sx={{marginBottom: '1.5rem', marginTop: '2.5rem'}}>Extra Large Padding</Typography>
        <FaPaper headline={"This is a paper Element <br> with xlarge padding."} padding="xlarge" sx={{maxWidth: '70vw', marginBottom: '1rem'}}>
          <Typography>
            Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa.
            Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis,
            ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo,
            fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae,
            justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper
            nisi. Aenean vulputate eleifend tellus. Aenean leo ligula, porttitor eu, consequat vitae, eleifend ac, enim.
            Aliquam lorem ante, dapibus in, viverra quis, feugiat a, tellus. Phasellus viverra nulla ut metus varius
            laoreet. Quisque rutrum. Aenean imperdiet. Etiam ultricies nisi vel augue. Curabitur ullamcorper ultricies
          </Typography>
        </FaPaper>
        <ShowCode codeString={example4} scope={{ React, FaPaper, Typography }} />

        <Typography variant={"h4"} sx={{marginBottom: '0.5rem', marginTop: '3rem'}}>API Reference</Typography>
        <Typography variant={"body2"} color="text.secondary" sx={{marginBottom: '2rem'}}>
          Complete list of all props supported by the FaPaper component.
        </Typography>

        <TableContainer component={Paper} sx={{marginBottom: '2rem', '& code': {fontSize: '0.875rem'}}}>
          <Table>
            <TableHead>
              <TableRow sx={{backgroundColor: 'primary.main'}}>
                <TableCell sx={{color: 'white', fontWeight: 'bold', width: '20%'}}>Prop</TableCell>
                <TableCell sx={{color: 'white', fontWeight: 'bold', width: '25%'}}>Type</TableCell>
                <TableCell sx={{color: 'white', fontWeight: 'bold', width: '15%'}}>Default</TableCell>
                <TableCell sx={{color: 'white', fontWeight: 'bold', width: '40%'}}>Description</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell><code>id</code></TableCell>
                <TableCell sx={{color: 'text.secondary'}}><code>string</code></TableCell>
                <TableCell sx={{color: 'text.secondary'}}><code>-</code></TableCell>
                <TableCell sx={{color: 'text.secondary'}}>Optional ID attribute for the component container.</TableCell>
              </TableRow>
              <TableRow>
                <TableCell><code>children</code></TableCell>
                <TableCell sx={{color: 'text.secondary'}}><code>any</code></TableCell>
                <TableCell sx={{color: 'text.secondary'}}><code>-</code></TableCell>
                <TableCell sx={{color: 'text.secondary'}}>Content to be displayed inside the paper component.</TableCell>
              </TableRow>
              <TableRow>
                <TableCell><code>elevation</code></TableCell>
                <TableCell sx={{color: 'text.secondary'}}><code>0 | 1 | 2 | 3</code></TableCell>
                <TableCell sx={{color: 'text.secondary'}}><code>2</code></TableCell>
                <TableCell sx={{color: 'text.secondary'}}>Shadow depth of the paper component.</TableCell>
              </TableRow>
              <TableRow>
                <TableCell><code>headline</code></TableCell>
                <TableCell sx={{color: 'text.secondary'}}><code>string</code></TableCell>
                <TableCell sx={{color: 'text.secondary'}}><code>-</code></TableCell>
                <TableCell sx={{color: 'text.secondary'}}>Headline text displayed at the top of the paper; supports HTML.</TableCell>
              </TableRow>
              <TableRow>
                <TableCell><code>headVariant</code></TableCell>
                <TableCell sx={{color: 'text.secondary'}}><code>'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'body2'</code></TableCell>
                <TableCell sx={{color: 'text.secondary'}}><code>"h3"</code></TableCell>
                <TableCell sx={{color: 'text.secondary'}}>Typography variant for the headline text.</TableCell>
              </TableRow>
              <TableRow>
                <TableCell><code>padding</code></TableCell>
                <TableCell sx={{color: 'text.secondary'}}><code>'small' | 'medium' | 'large' | 'xlarge'</code></TableCell>
                <TableCell sx={{color: 'text.secondary'}}><code>"medium"</code></TableCell>
                <TableCell sx={{color: 'text.secondary'}}>Padding size applied to the paper component.</TableCell>
              </TableRow>
              <TableRow>
                <TableCell><code>sx</code></TableCell>
                <TableCell sx={{color: 'text.secondary'}}><code>any</code></TableCell>
                <TableCell sx={{color: 'text.secondary'}}><code>-</code></TableCell>
                <TableCell sx={{color: 'text.secondary'}}>Material-UI sx prop for custom styling of the container box.</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>

        <Typography variant={"body2"} color="text.secondary" sx={{fontStyle: 'italic'}}>
          * Required prop
        </Typography>
      </Box>
  );
};

export default FactureeCompPaperExmpl;
